import React from "react";
import styles from "../../styles/Loader.module.css";

export default function Loader() {
  return (
    <div className={styles.wrapper}>
      <DotsLoader />
    </div>
  );
}

export function DotsLoader({ scale = 1 }: { scale?: number }) {
  return (
    <div style={{ transform: `scale(${scale})`, transformOrigin: "center" }}>
      <div className={styles.loader}>
        {Array.from({ length: 9 }).map((_, i) => (
          <div key={i} />
        ))}
      </div>
    </div>
  );
}
